import type { FC, PropsWithChildren } from "react";

import type { SignalEventType } from "app/pages/sales-intelligence/sub-modules/account-overview/company/services/signals/types";
import SignalsIntentTooltip from "app/pages/sales-intelligence/sub-modules/signals/components/tooltips/SignalsIntentTooltip/SignalsIntentTooltip";
import { COLUMN_INTENT_SIGNAL_NAME } from "app/pages/sales-intelligence/sub-modules/signals/constants";
import createIntentSignalsTooltipViewModel from "app/pages/sales-intelligence/sub-modules/signals/models/view/signals-tooltip/intent/factory";
import type SignalsTooltipViewModel from "app/pages/sales-intelligence/sub-modules/signals/models/view/signals-tooltip/SignalsTooltipViewModel";
import { createTooltipId } from "app/pages/sales-intelligence/sub-modules/signals/utils/tableColumns";

interface ISignalIntentTooltipContainerProps {
    redirectLink: URL["href"];
    getSignalTypeLink: (eventType: SignalEventType) => URL["href"];
    onViewAll: () => void;
    row: any;
}

export const SignalIntentTooltipContainer: FC<PropsWithChildren<ISignalIntentTooltipContainerProps>> = ({
    row,
    children,
    redirectLink,
    getSignalTypeLink,
    onViewAll,
}) => {
    const intentTopicScopeList = row[COLUMN_INTENT_SIGNAL_NAME] ?? [];

    if (intentTopicScopeList.length === 0) {
        return <>{children}</>;
    }

    const createViewModel = (itemsLimit: number): SignalsTooltipViewModel =>
        createIntentSignalsTooltipViewModel({
            intentTopicScopeList,
            itemsLimit,
        });

    return (
        <SignalsIntentTooltip
            key={`intent-${createTooltipId(row)}`}
            redirectLink={redirectLink}
            createViewModel={createViewModel}
            onViewAll={onViewAll}
            getSignalTypeLink={getSignalTypeLink}
        >
            <>{children}</>
        </SignalsIntentTooltip>
    );
};
